import type { AccountLoginJobCreateRequest } from "./types";

export interface AccountLoginFormValues {
  name: string;
  email: string;
  password: string;
  user_agent: string;
  proxy_url: string;
  max_concurrent_tasks?: number | "";
  requests_per_second: number;
}

export function buildAccountLoginJobCreateRequest(
  values: AccountLoginFormValues,
  targetAccountId?: string | number,
): AccountLoginJobCreateRequest {
  return {
    name: values.name.trim() || undefined,
    email: values.email,
    password: values.password,
    user_agent: values.user_agent.trim() || undefined,
    proxy_url: values.proxy_url.trim() || undefined,
    target_account_id: targetAccountId,
    ...(typeof values.max_concurrent_tasks === "number"
      ? { max_concurrent_tasks: values.max_concurrent_tasks }
      : {}),
    requests_per_second: values.requests_per_second,
  };
}
